import React from 'react';
import { minTraceSpaceOptions } from 'shared/data/selectOptions';
import SelectComponent from 'shared/components/SelectComponent';

const MinTraceSpace = (props) => {
  const name = 'min_trace_space';

  const {
    label,
    options,
    parameters,
    onChangeParameter,
    required,
    tooltip,
    inputId,
    groupName,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <SelectComponent
      label={label}
      required={required}
      name={name}
      onChange={onChange}
      options={options}
      tooltip={tooltip}
      selected={parameters[name]}
      groupName={groupName}
      inputId={inputId}
      disabled={disabled} />
  );
};

MinTraceSpace.defaultProps = {
  inputId: 'min-trace-space',
  options: minTraceSpaceOptions,
  label: Spree.translations.parameters.min_trace_space,
  tooltip: Spree.helpForParameters.min_trace_space,
};

export default MinTraceSpace;
